module.exports = __webpack_public_path__ + "img/Feature-6.149baef.svg";